import { useCallback } from 'react';
import { useDataFetchingClient } from 'data-fetching-client';
import { GET_TICKET_DETAILS_QUERY } from '../data/useTicket';
import { GET_RELEVANT_THREADS_FOR_USER_QUERY } from '../data/useTicketThreads';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
import { useIsPreview } from './useIsPreview';
export function usePrefetchTicketData() {
  const client = useDataFetchingClient();
  const isPreview = useIsPreview();
  return useCallback(ticketId => {
    if (isPreview) return;
    void client.query({
      query: GET_TICKET_DETAILS_QUERY,
      variables: {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId(),
        params: {
          ticketId
        }
      }
    });
    void client.query({
      query: GET_RELEVANT_THREADS_FOR_USER_QUERY,
      variables: {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId(),
        params: {
          ticketId
        }
      }
    });
  }, [client, isPreview]);
}